import { render, staticRenderFns } from "./SimpleItemLTSCardSplitted.vue?vue&type=template&id=8cdd4afe&scoped=true&"
import script from "./SimpleItemLTSCardSplitted.vue?vue&type=script&lang=js&"
export * from "./SimpleItemLTSCardSplitted.vue?vue&type=script&lang=js&"
import style0 from "./SimpleItemLTSCardSplitted.vue?vue&type=style&index=0&id=8cdd4afe&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cdd4afe",
  null
  
)

export default component.exports